import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ChartProperties } from '@nimbus-library/features/charts/models/chart.model';
import { ChatChartType } from '@nimbus-global/features/chat-chart/models/chat-chart.model';
import { CompanionToolCallRecord } from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { ICompanionChatBuilder } from './chart-builders/companion-chat-builder.interface';
import { OutcomeChartBuilder } from './chart-builders/outcome-chart.builder';

export interface ICompanionChatChart {
  type: ChatChartType;
  data$: Observable<ChartProperties>;
}

@Injectable({ providedIn: 'root' })
export class CompanionChatChartService {
  private readonly buildersByTool: Map<string, ICompanionChatBuilder>;

  public constructor(outcomeBuilder: OutcomeChartBuilder) {
    const builders: ICompanionChatBuilder[] = [outcomeBuilder];
    this.buildersByTool = new Map(builders.map((b) => [b.toolName as string, b]));
  }

  public build(toolCalls: CompanionToolCallRecord[]): ICompanionChatChart | null {
    for (const call of toolCalls ?? []) {
      const builder = this.buildersByTool.get(call?.toolName as string);
      if (!builder) {
        continue;
      }
      const chart = builder.build(call);
      if (chart) {
        return { type: builder.chartType, data$: of(chart) };
      }
    }
    return null;
  }
}
